export default {
    Menu: 'Menu',
    Add: 'Add',
    Modify: 'Modify',
    Delete: 'Delete',
    Scale: 'Scale',
    Color: 'Color',
    Materials: 'Materials',
    Mesh: 'Mesh',
    Size: 'Size',
    Details: 'Details',
    Quantity: 'Quantity',
    EnterYourQuantity: 'Enter my quantity',
    ChooseQuantity: 'Choose quantity',
    Pieces: 'pcs',
    Piece: 'piece',
    SavePercent: 'Save {pct}%',
    AddToCart: 'Add to cart',
    AddToCartTitle: 'Add to cart',
    Cart: 'Cart',
    Total: 'Total',
    Subtotal: 'Subtotal',
    Shipping: 'Shipping',
    Shape: 'Shape',
    PickShape: 'Pick a shape to add to the canvas',
    ShapeAdded: 'Shape added. Click another one to replace it.',
    Clipart: 'Illustration',
    PickClipart: 'Pick an illustration to add to the canvas',
    ClipartAdded: 'Illustration added. Click another one to replace it.',
    SearchClipart: 'Search for an illustration…',
    NoClipartFound: 'No illustration found',
    Cliparts: 'Cliparts',
    Illustration: 'Illustration',
    AiImage: 'AI Image',
    AiImageIntro: 'Describe what you want, pick a format, and get 2 proposals.',
    AiImageFormat: 'Format',
    AiFormatSquare: 'Square',
    AiFormatPortrait: 'Portrait',
    AiFormatLandscape: 'Landscape',
    AiImagePlaceholder: 'e.g. a stylized red fox, flat style, transparent background…',
    AiGenerate: 'Generate',
    AiGenerating: 'Generating…',
    AiPickResult: 'Pick a proposal',
    AiImageAdded: 'Image added to canvas',
    AiImageError: 'Image generation failed',
    AiNoResult: 'No image generated',
    AiImageNotInPlan: 'AI image generation is not included in your plan. Activate the option to use it.',
    SearchIllustration: 'Search an illustration…',
    NoIllustrationFound: 'No illustration found',
    IllustrationIntro: 'Search vector illustrations to add to the canvas.',
    IllustrationError: 'Illustration search failed',
    IllustrationNotVector: 'This result is not a usable vector',
    Texts: 'Texts',
    Images: 'Images',
    Colors: 'Colors',
    ThemeEditDesc: 'Edit the texts, images and colors of the theme.',
    ThemeNotFound: 'Theme not found.',
    ThemeNoEditable: 'This theme has no editable elements.',
    Helpers: 'Rulers, guides & grid',
    Rulers: 'Rulers',
    RulersHint: 'Pixel graduation',
    Guides: 'Guides',
    GuidesHint: 'Markers at 25 / 50 / 75 %',
    GridHint: 'Grid overlay',
    Snapping: 'Snapping',
    SnappingHint: 'Align to center / grid / other objects',
    LeaveConfirm: 'Are you sure you want to lose your changes?',
    Products: 'Products',
    Customization: 'Customization',
    BackToCustomizationType: 'Customization type',
    SaveNoChanges: 'No changes to save yet',
    ChooseCategory: 'Choose a category',
    SelectProduct: 'Select a product',
    Loading: 'Loading',
    ProofLogoTooLarge: 'Logo too large (500 KB maximum).',
    ProofLogoInvalidType: 'Unsupported image format.',
    ProofLogoImported: 'Logo imported.',
    ProofLogoImportFailed: 'Logo import failed.',
    YouHaveProjects: 'You have {count} project(s) in progress',
    ResumeProject: 'Resume a project',
    ResumeProjectHint: 'Pick up where you left off.',
    YourProjects: 'Your projects in progress',
    OpenProject: 'Open this project',
    NoProjects: 'No projects in progress.',
    AppUpdating: 'Updating the application…',
    DraftRestored: 'Draft restored',
    SaveExpiredTitle: 'Save expired',
    SaveExpiredMessage: 'This save has expired or is no longer available.',
    Continue: 'Continue',
    PhotoFramePickShape: 'Choose a frame',
    PhotoFramePlacePhoto: 'Place and adjust your photo',
    PhotoFrameChangePhoto: 'Change photo',
    PhotoFrameDropTitle: 'Drop a photo here',
    PhotoFrameDropSub: 'or click to upload',
    Rotation: 'Rotation',
    Reset: 'Reset',
    ProofLogoTitle: 'Proof logo',
    ProofLogoUseSite: 'Keep {site}\'s logo',
    ProofLogoUseMine: 'With my own logo',
    ProofLogoUseMineDesc: 'Only on the proof, not on the print files.',
    ProofLogoNone: 'Without any logo',
    ProofLogoDropTitle: 'Upload your logo',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'Validating your order',
    LoadingStepScreenshots: 'Generating previews',
    LoadingStepPrintFile: 'Generating print files',
    LoadingStepUpload: 'Uploading to server',
    LoadingStepSave: 'Saving configuration',
    LoadingGraduation: 'Loading graduation',
    OptimizingImage: 'Optimizing image',
    LoadingScene: 'Loading scene',
    LoadingStepZip: 'Building the zip',
    LoadingProduct: 'Loading product',
    Category: 'Category',
    Product: 'Product',
    Summary: 'Summary',
    Zone: 'Zone',
    SelectZone: 'Select a zone',
    SelectAZone: 'Select a zone',
    Undo: 'Undo',
    Redo: 'Redo',
    Recenter: 'Recenter view',
    HelpersIntro: 'Zone borders, grid, rulers and guides on the 2D canvas.',
    ShowZoneBordersHint: 'Zone frames on the main canvas',
    Save: 'Save',
    Saving: 'Saving',
    Grid: 'Grid',
    SwitchTo3D: 'Switch to 3D',
    PrintZone: 'Print zone',
    ViewModeSwitch: 'Display mode',
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Dual',
    ShowZoneBorders: 'Show zone borders',
    ShowZoneBordersHelp: 'Display the dashed border and label of zones on the 2D canvas.',
    ManageElements: 'Manage elements',
    StartWithTheme: 'Start with a theme',
    Customize: 'Customize',
    FromPriceForQty: 'From {price} for {qty} unit(s)',
    FromThemeLibrary: 'From our theme library',
    StartFromScratch: 'Start from scratch',
    Or: 'Or',
    PreviousCreations: 'Previous creations',
    WithModel: 'With a model',
    Search: 'Search',
    SubCategory: 'Sub-Category',
    Next: 'Next',
    Previous: 'Previous',
    Validate: 'Validate',
    DownloadMyProject: 'Download my project',
    EditThemeColors: 'Edit elements colors',
    AddPattern: 'Add pattern',
    EditGraduation: 'Edit graduation',
    Pattern: 'Pattern',
    PatternHint: 'The pattern is repeated across the whole customization area. Its colors can be customized.',
    SearchTheme: 'Search a theme (title or tag)',
    Theme: 'Theme',
    Graduation: 'Graduation',
    Graduation_s: 'Graduation(s)',
    ErrorOccurred: 'An error has occurred.',
    ReloadPage: 'Please reload your page.',
    LoadingCategories: 'Loading categories',
    ShowAll: 'Show all',
    Categories: 'Categories',
    ComingSoon: 'Soon',
    DropImageHere: 'Drag and drop an image',
    ReleaseToImport: 'Release to import',
    OrClickToBrowse: 'or click to browse',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        'This print method works with defined colors. We recommend using vectorized files for optimal results.',
    SearchInPhotoGallery: 'Search in our photo gallery',
    QrCode: 'QR Code',
    QrCodeContent: 'Content (URL, text, email…)',
    QrCodePlaceholder: 'https://example.com',
    QrCodeForeground: 'QR color',
    QrCodeBackground: 'Background',
    QrCodeTransparentBg: 'Transparent background',
    QrCodeErrorLevel: 'Error tolerance',
    QrCodeErrorL: '7% (low density)',
    QrCodeErrorM: '15% (standard)',
    QrCodeErrorQ: '25%',
    QrCodeErrorH: '30% (high)',
    QrCodeEmptyPreview: 'Enter content to preview',
    QrCodeRequired: 'QR Code content is required.',
    QrCodeInvalidUrl: 'Enter a valid QR Code URL (http:// or https://).',
    QrCodeAdd: 'Add QR code',
    QrCodeEditOnlyColors:
        'Only colors can be modified after a QR code has been created. To change its content, delete it and create a new one.',
    ImageQualityGood: 'Good resolution',
    ImageQualityMedium: 'Medium resolution',
    ImageQualityLow: 'Low resolution — upload a larger image or shrink it on the canvas',
    LowQualityAlertTitle: 'Warning',
    LowQualityAlertMessage:
        'Your design contains low-resolution images, or images that have been enlarged too much compared to their original resolution. You must either fix your design or accept the risk of pixelation in the print.',
    LowQualityAlertHint: 'Low resolution threshold:',
    LowQualityAcceptRisk: 'I accept the risk of pixelation for my low-quality images',
    Preview: 'Preview',
    Bold: 'Bold',
    Italic: 'Italic',
    Underline: 'Underline',
    FontSize: 'Size',
    SelectFont: 'Select a font',
    UploadFont: 'Upload my font',
    UploadFontHint: 'TTF or OTF · 5 MB max',
    CustomFontBadge: 'custom',
    CustomFontImported: 'Font imported.',
    CustomFontFormatError: 'Unsupported format (TTF or OTF only).',
    CustomFontTooLarge: 'Font too large (5 MB maximum).',
    CustomFontImportFailed: 'Font import failed.',
    CustomFontRemoved: 'Font removed.',
    RecentFonts: 'Recent',
    Clear: 'Clear',
    TextColor: 'Text color',
    TextOutline: 'Outline',
    AddOutline: 'Add outline',
    RemoveOutline: 'Remove outline',
    PickColor: 'Pick a color',
    PickThemeCategory: 'Pick a category to explore themes',
    NoThemeInCategory: 'No themes in this category',
    ThemePreviewLabel: 'Theme preview',
    PickAnotherTheme: 'Pick another theme',
    Keep: 'Keep',
    LoadingThemes: 'Loading themes',
    LoadingPatterns: 'Loading patterns',
    EditableThemeColors: 'Editable elements colors',
    PickAColor: 'Pick a color',
    SelectALayout: 'Select a layout',
    CreateLayer: 'Create layer',
    LastDownloads: 'Last downloads',
    Cancel: 'Cancel',
    Back: 'Back',
    BackToProvider: 'Back to {provider}',
    LayerNotFound: 'Layer not found',
    ChangeImage: 'Change image',
    ChangePattern: 'Change pattern',
    Resize: 'Resize',
    RemoveBackground: 'Remove background',
    Processing: 'Processing…',
    AddFilter: 'Add filter',
    PhotoCredit: 'Photo by {author} on {provider}',
    PhotoBy: 'Photo by',
    On: 'on',
    LinkRedirectionWarning: 'This link is taking you to this following website',
    LoadMore: 'Load more',
    EditLayer: 'Edit layer',
    Import: 'Import',
    FromYourDevice: 'From your device',
    FromImageGallery: 'From image gallery',
    NoGraduationsAvailable: 'No graduations available',
    Confirm: 'Confirm',
    CustomizeProduct: 'Customize your product',
    WriteYourText: 'Write your text here',
    Text: 'Text',
    Image: 'Image',
    DesignSummary: 'Summary of your design',
    AddOptions: 'Add options',
    TermsOfSale: 'General terms of sale',
    TOSMessage:
        'I certify that my design is compliant with [General terms of sale](#) and in particular the article 8- Intellectual property',
    IValidateMyCreation: 'I validate my creation',
    FunctionalityNotAvailable: 'Functionality not available',
    Lock: 'Lock',
    Unlock: 'Unlock',
    AddLayer: 'Add an element',
    LayerSectionTemplates: 'Templates',
    LayerSectionText: 'Text & data',
    LayerSectionImages: 'Images',
    LayerSectionDecor: 'Decoration',
    LayerSectionTools: 'Tools',
    DragLayersToReorder: 'Drag layers to reorder them',
    PleaseAgreeTOS: 'Please agree to the terms and conditions to validate your creation.',
    ErrorExportPrintFile: 'An error occurred while exporting the print file.',
    ErrorExportProofFile: 'An error occurred while exporting the proof file.',
    ErrorAddToCart: 'An error occurred while adding to cart: ',
    Gabarit: 'Template',
    FicheTechnique: 'Technical sheet',
    GeneratingPrintFile: 'Generating print file...',
    GeneratingProofFile: 'Generating proof document...',
    LeaveCustomizer: 'Leave customizer',
    LeaveManager: 'Leave Elements Manager',
    ChangeProductTitle: 'Your design will be erased.',
    ChangeProductConfirm: 'Changing product will permanently erase your design. Are you sure?',
    Duplicate: 'Duplicate',
    LoadingTheme: 'Loading theme',
    LoadingPattern: 'Loading pattern',
    Expand: 'Expand',
    Shrink: 'Shrink',
    TiltLeft: 'Tilt left',
    TiltRight: 'Tilt right',
    Rotate: 'Rotate',
    Move: 'Move',
    Reposition: 'Reposition',
    MoveUp: 'Move up',
    MoveDown: 'Move down',
    MoveLeft: 'Move left',
    MoveRight: 'Move right',
    NoCustomization: 'There is no design on the product.',
    MissingCustomization: 'Missing customization',
    SelectGraduation: 'Select a graduation',
    ProofTitle: 'Proof document',
    ProofDesignTitle: '2D Design',
    ProofScreenshotsTitle: '3D Renders',
    ProofSelectedInksTitle: 'Selected colors',
    Warning: 'Warning',
    SelectZoneBeforeTheme: 'Please select a zone before choosing a theme.',
    ThemeTooManyElements: 'Theme contains too many elements. Please choose another',
    Error: 'Error',
    ProductNotFound: 'Product not found',
    ProductNotFoundMessage: 'Product not found, you will be redirected to the home page.',
    NoCategoryAvailable: 'No category available',
    CategoryNotFound: 'Category not found',
    CategoryNotFoundMessage: 'Category not found, you will be redirected to the home page.',
    Unavailable: 'Unavailable',
    // Saved Configurations
    SavedConfigurations: 'Saved Configurations',
    YourSavedConfigurations: 'Your Saved Configurations',
    NoSavedConfigurations: 'No saved configurations for this product',
    ConfigurationName: 'Configuration name',
    LoginToSave: 'Sign in to find your designs in your account.',
    Login: 'Sign in',
    LoggingIn: 'Signing in…',
    ContinueWithoutAccount: 'Continue without an account',
    SaveEmailPlaceholder: 'Your email address',
    SaveEmailHint: 'You will receive a link to resume your project (kept for 30 days).',
    SaveConfirmTitle: 'Project saved',
    SaveConfirmMessage: 'Your project has been saved. An email with the resume link has just been sent to you.',
    Created: 'Created',
    Expires: 'Expires',
    Load: 'Load',
    ConfirmDeleteConfiguration: 'Are you sure you want to delete this configuration?',
    Close: 'Close',
    Step: 'Step',
    CustomizeProductDesc: 'Choose how to begin: start from a blank canvas or pick a theme below.',
    StartFromScratchDesc: 'A blank canvas to add text, images, and shapes freely—no preset layout.',
    ChooseProductDesc: 'Pick a product to customize.',
    // Printing method
    PrintMethod: 'Printing method',
    ChoosePrintMethod: 'Choose your method',
    ChoosePrintMethodDesc: 'Select the printing method for this product. This choice is final for this customization.',
    Digital: 'Digital',
    ScreenPrinting: 'Screen printing',
    LaserEngraving: 'Laser engraving',
    Embroidery: 'Embroidery',
    DisableEmbroideryEffect: 'Disable embroidery effect',
    RestrictedToPalette: 'Colors limited to the palette',
    ChooseInks: 'Choose your inks',
    ChooseThreads: 'Choose your threads',
    AppliesToZone: 'Zone: {zone}',
    Ink: 'Ink',
    Thread: 'Thread',
    AddThread: 'Add a thread',
    RemoveThread: 'Remove a thread',
    InkOverride: 'Force an ink',
    ThreadOverride: 'Force a thread',
    SuggestInks: 'Suggested inks',
    SuggestThreads: 'Suggested threads',
    RecommendColorsFromImage: 'Recommend colors from image',
    NoColorSuggestion: 'No color suggestion for this image.',
    InkAssistantHelp: 'This method uses a fixed palette of {count} colors.',
    InkAssistantQuestion: 'How would you like to set your colors?',
    InkAssistantUpload: 'Help me find my colors',
    InkAssistantUploadDesc: 'Upload your image, logo or artwork — we automatically detect the closest palette colors.',
    InkAssistantManual: 'I pick my colors manually',
    InkAssistantManualDesc: 'Select each color, one by one, from the palette.',
    InkAssistantAnalyzing: 'Analyzing your image…',
    InkChoiceModifiableHint: 'This choice can be changed at any time.',
    InkAssistantResultDesc: 'Here are the palette colors closest to your image.',
    InkDuplicateWarning:
        'This color is already selected for another ink / thread. Selecting it a second time will flatten the colors permanently! Are you sure?',
    Selected: 'Selected',
    Add: 'Add',
    VectorizeImage: 'Vectorize image',
    Vectorizing: 'Vectorizing…',
    VectorizePreviewTitle: 'Vectorization result',
    VectorizeIntro:
        'The image will be converted to vector and limited to the chosen inks. Validate the result to apply it.',
    VectorizeApply: 'Apply vector',
    VectorizeConsent:
        'I understand that I am responsible for checking the vectorization result and that the print will reflect it.',
    VectorizeThreshold: 'Threshold (detail / background)',
    VectorizeThresholdHint:
        'Adjust to fine-tune: lower removes more light background (line-art); higher keeps more light areas.',
    VectorizeDenoise: 'Reduce noise',
    VectorizeDenoiseHint: 'Removes specks and small stray dots.',
    VectorizeSmoothing: 'Smoothing',
    VectorizeSmoothingHint: 'Rounds the outlines (fewer corners).',
    ZoomIn: 'Zoom in',
    ZoomOut: 'Zoom out',
    Fit: 'Fit',
    // --- FO redesign keys (were called without existing → not overridable) ---
    Apply: 'Apply',
    Edit: 'Edit',
    Support: 'Support',
    VectorizeAcknowledge:
        'I understand that I am responsible for checking the vectorization result and that the print will reflect it.',
    Crop: 'Crop',
    Font: 'Font',
    Style: 'Style',
    Outline: 'Outline',
    Steps: 'Steps',
    Tools: 'Tools',
    ThemeColors: 'Colors',
    Minimize: 'Minimize',
    MoveLayerUp: 'Move layer up',
    MoveLayerDown: 'Move layer down',
    DragLayer: 'Drag to reorder',
    NoResult: 'No result',
    SearchElement: 'Search an element…',
    ExpertMode: 'Expert mode',
    Finish: 'Finish',
    ChooseImageOrPhoto: 'Choose an image or photo',
    WizardIntro: 'Follow the steps for a personalized creation in 1 minute.',
    WizardIntroExpert: 'Want more freedom? Switch to expert mode.',
    ClickToChooseImage: 'Click here to choose an image or photo',
    ChooseCategoryDesc: 'Select a product family to start.',
    SelectProductDesc: 'Select a product to start…',
    FinalReview: 'Last step',
    StartWithThemeDesc: 'Start from a pre-configured design.',
    WithModelDesc: 'Pick a ready-made template.',
    ExpertModeConfirmTitle: 'Expert Mode',
    ExpertModeConfirmMsg:
        'Switching to expert mode is a final choice. This mode is slightly more complex to use, but lets you add and edit elements without any constraints.',
    ExpertModeHint: 'Complete your design without limits — add text and photos as you wish.',
    VariableData: 'Variable data',
    PhotoFrame: 'Photo frame',
    PhotoFrameHint: 'Pick a shape, then put a photo inside it.',
    PhotoFrameChooseShape: '1. Frame shape',
    PhotoFrameChangeShape: 'Change shape',
    PhotoFramePickPhoto: 'Choose a photo',
    FromLibrary: 'From library',
    VectorizeCancel: 'Cancel',
    VectorizeFailed: 'Vectorization failed. Try again or change image.',
    Before: 'Before',
    After: 'After',
    VariableText: 'Variable text',
    VariableTextIntro:
        'This feature works like a mail merge: you get your product printed as a unique copy for each text, and the quantity is automatically computed for your cart.',
    VariableTextData: 'Data (one line = one copy)',
    VariableTextPlaceholder: 'John Doe\nJane Smith\nPaul Baker',
    VariableTextImport: 'Import a CSV / Excel',
    SessionImages: 'Imported images',
    Accept: 'Accept',
    UploadConsentMessage:
        'I confirm that none of my files will violate applicable laws, copyright, or third-party rights.',
    VariableTextNoData: 'Add at least one line to preview.',
    VdpFields: 'Variable fields',
    VdpFieldName: 'Field name',
    VdpPlace: 'Place',
    VdpPlaced: 'Placed',
    VdpAddField: 'Add a field',
    VdpAddRow: 'Add a row',
    VdpLine: 'Row',
    VdpMaxRowsReached: 'Maximum stock reached',
    VdpImportTruncated: 'Import capped to available stock',
    VdpEnterData: 'Enter my data',
    Done: 'Done',
    VdpFieldStyle: 'Field style',
    VdpFirstRowHeader: 'First row is header (field names)',
    VdpQuantity: 'Quantity: {qty}',
    VdpQuantityHint: 'Quantity is set by the number of lines of your variable text.',
    VariableTextOnlyOne: 'Only one Variable text field per creation.',
    VariableTextEmptyFile: 'Empty file or no usable column.',
    VariableTextImportError: 'Could not read this file. Use a CSV or paste the text.',
    VariableTextExcelUnavailable: 'Excel reading unavailable. Export to CSV or paste the text.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks: 'Selected inks: {chosen}/{required}. Choose every ink before validating.',
    PreflightScreenColorCount: 'Screen printing: your design is limited to {count} ink(s).',
    PreflightMinStroke: 'Recommended minimum stroke: {mm} mm. Thinner strokes may print poorly.',
    PreflightMinFont: 'Recommended minimum font size: {pt} pt.',
    PreflightLaserMonochrome: 'Laser engraving: the final output will be monochrome.',
    // --- Tunnel refonte (?ui=new shell) ---
    More: 'More',
    All: 'All',
    AllCategories: 'All categories',
    SearchCategory: 'Search a category…',
    NoProductAvailable: 'No product in this category.',
    ChooseProductTitle: 'Choose the product to personalise',
    PrintMethodQuestion: 'How do you want to print your {product}?',
    PrintMethodIntro: 'Each method has its strengths and constraints — it defines the available colours and finishes.',
    StartLabel: 'Starting point',
    StartTitle: 'Start from a theme, or a blank page',
    StartIntro: 'A theme = a ready-made design to tweak (fastest). Blank page = full control.',
    StepProduct: 'Product',
    StepMethod: 'Method',
    StepStart: 'Start',
    StepDesign: 'Design',
    // --- Simplified journey + colour constraints ---
    ChangeTheme: 'Change theme',
    BackToTheme: 'Back to theme',
    Recent: 'Recent',
    WhiteNotPrintable: 'White cannot be printed (transparent).',
    LetterSpacing: 'Letter spacing',
    OutlineActive: 'Outline enabled',
    OutlineThickness: 'Outline thickness',
    AlignLeft: 'Align left',
    AlignCenter: 'Center',
    AlignRight: 'Align right',
    Uppercase: 'Uppercase',
    TextFormatting: 'Formatting',
    FontSizeLabel: 'Font size',
    SelectionActions: 'Selection actions',
    DragToMove: 'Drag to move',
    DragToResize: 'Drag to resize',
    DragToRotate: 'Drag to rotate',
    MoveUpOneLevel: 'Move up one level',
    MoveDownOneLevel: 'Move down one level',
    BringToFront: 'Bring to front',
    Front: 'Front',
    SendToBack: 'Send to back',
    BackgroundNeverUnderPattern: 'Background (never under a background pattern)',
    EyedropperColor: 'Color eyedropper',
    PresetColors: 'Preset colors',
    RecentColors: 'Recent colors',
    Palette: 'Palette',
    HexValue: 'Hex value',
    AiResultsHint: 'Find all suggestions in the Image tab',
    Notifications: 'Notifications',
    Zoom: 'Zoom',
    GuidedCustomization: 'Guided customization',
    Actions: 'Actions',
    InkAssistantYourChoice: 'You chose:',
    InkAssistantCorrectQuestion: 'Would you like to change this choice?',
    '': ''
};
